import { useQuery } from '@tanstack/react-query';
import React from 'react';

import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import {
    PerformanceMembersDataResponse,
    GetPerformanceQuery,
    PerformanceFormFillsDataResponse
} from '../types';
import { PERFORMANCE_FORM_FILLS_KEY, PERFORMANCE_MEMBERS_KEY } from './constants';

export const usePerformanceMembersRequest = (query?: GetPerformanceQuery) => {
    const req = useRequest();

    const request = React.useCallback(() => {
        return req<PerformanceMembersDataResponse>({
            url: `${envVars.API_COMMERCE_HOSTNAME}enterprise/member-reports`,
            query
        });
    }, [req, query]);

    return useQuery({
        queryFn: request,
        queryKey: [PERFORMANCE_MEMBERS_KEY, query]
    });
};

export const usePerformanceFormFillsRequest = (query?: GetPerformanceQuery) => {
    const req = useRequest();

    const request = React.useCallback(() => {
        return req<PerformanceFormFillsDataResponse>({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/form-fill-reports`,
            query
        });
    }, [req, query]);

    return useQuery({
        queryFn: request,
        queryKey: [PERFORMANCE_FORM_FILLS_KEY, query]
    });
};
